'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * 照会・参照（ledger）配下のリソース一覧画面の共通レイアウト。
 *
 * pathless ルート（URL には現れない）。clocking-record と同じく全幅で、
 * ヘッダー帯（{@link LedgerHeader}）+ スクロールするコンテンツ（{@link LedgerContent}）を
 * 各ページが描画する。サイドバーは持たない。
 */
export const Route = createFileRoute('/_individual/individual/portal/lookup/_ledger')({
  component: LedgerLayout
});
function LedgerLayout() {
  return <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col bg-neutral-bottom-fill">
      <Outlet />
    </div>;
}